import { Component } from '@angular/core';
import { UserService } from './services/user.service';
import { LanguageService } from 'shared';
import { IUser } from './interfaces/user';
import { CurrentUserService } from 'projects/serviceportal/src/app/services/current-user.service';
import { tap, first } from 'rxjs/operators';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent {
  title = 'admin';
  user: IUser;

  constructor(
    public userService: UserService,
    private readonly languageService: LanguageService,
    private readonly currentUserService: CurrentUserService,
  ) {
    // Application configuration is loaded by an APP_INITIALIZER in main.ts,
    // so by the time AppComponent is constructed it's already available to
    // anyone that needs it (e.g. MSAL factories).
    this.currentUserService.currentUser$
      .pipe(
        first(),
        tap((user) => {
          this.languageService.setupLanguages(user.language);
        }),
      )
      .subscribe();
  }
}
